export const translationES = {
  translation: {
    navBar: {
      title: {
        calendar: "Elegir fechas",
        accommodation: "Alojamiento",
        extras: "Extras",
        summary: "Resumen",
        details: "Datos",
        payment: "Pago",
        success: "Confirmación",
      },
    },
    cart: {
      title: {
        calendar: "Ver alojamientos",
        accommodation: "Continuar a extras",
        extras: "Revisar tu reserva",
        summary: "Introduce tus datos",
        details: "Continuar al pago",
        payment: "Finalizar reserva",
      },
      selectArrivalDate: "Por favor, selecciona una fecha de llegada",
      selectDepartureDate: "Por favor, selecciona una fecha de salida",
      priceFrom: "Desde",
    },
    weekDays: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"],
    months: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
    shortMonths: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
    accommodation: {
      AMS: {
        tags: [],
        hub: {
          title: "Hub",
          exerpt:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          description:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          imagePath: "/assets/images/accomodation/hub_AMS/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            { src: "see_the_top_hub.jpg", alt: "Ver la Hub superior" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interior de la Hub superior",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Ver la Hub inferior" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interior de la Hub inferior",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sí, puedes sentarte en la cama",
            },
            {
              src: "play_your_music_with_bluetooth.jpg",
              alt: "Pon tu música por Bluetooth",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refréscate bajo la ducha de lluvia",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "hair_&_makeup_area.jpg",
              alt: "Zona de peinado y maquillaje",
            },
          ],
        },
        howManyTravellers: {
          title: "¿Cuántos viajeros?",
          content:
            "Todos nuestros espacios cuentan con camas cómodas, luces ambientales y tecnología moderna. La pregunta es: ¿cómo quieres alojarte? <br /><br />Nuestras Hubs son ideales para viajeros solitarios, parejas o amigos que valoran la privacidad y un ambiente acogedor.<br /><br />Selecciona de 1 a 4 viajeros para ver el cambio de precio.",
        },
        addAnotherAccomodation: {
          title: "Añadir Hub",
          hub: {
            title: "Hub",
            description:
              "Hub privada con cama king-size – perfecta para uno o dos viajeros.",
          },
        },
      },
      CPH: {
        tags: ["Sauna en el hotel"],
        hub: {
          title: "Hub",
          exerpt:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          description:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          imagePath: "/assets/images/accomodation/hub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            { src: "see_the_top_hub.jpg", alt: "Ver la Hub superior" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interior de la Hub superior",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Ver la Hub inferior" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interior de la Hub inferior",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "hallway.jpg", alt: "Pasillo" },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Relájate en nuestra sauna",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          exerpt:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio. Genial para amigos o hermanos.",
          description:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio. Genial para amigos o hermanos.",
          imagePath: "/assets/images/accomodation/twinHub_CPH/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Interior de la Twin Hub superior",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Interior de la Twin Hub inferior",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 colchones individuales con un divisor",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Relájate en nuestra sauna",
            },
          ],
        },
        room: {
          title: "Quad Room",
          exerpt:
            "¿Necesitas más espacio? La Quad Room tiene capacidad para hasta 4 viajeros. Ideal para amigos o familias. Con baño privado. Apta para personas con movilidad reducida.",
          description:
            "La Quad Room tiene capacidad para hasta 4 viajeros. Ideal para amigos o familias. Con baño privado. Apta para personas con movilidad reducida.",
          imagePath: "/assets/images/accomodation/quadRoom_CPH/",
          images: [
            {
              src: "quad_room_with_4_bunk_beds.jpg",
              alt: "Habitación Quad con 4 literas",
            },
            {
              src: "quad_room_with_a_double_bed_and_2_bunks.jpg",
              alt: "Habitación Quad con una cama doble y 2 literas",
            },
            { src: "private_bathroom.jpg", alt: "Baño privado" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refréscate bajo la ducha de lluvia",
            },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            {
              src: "sweat_it_out_in_our_sauna.jpg",
              alt: "Relájate en nuestra sauna",
            },
          ],
        },
        howManyTravellers: {
          title: "¿Cuántos viajeros?",
          content:
            'Todos nuestros alojamientos ofrecen camas cómodas y tecnología inteligente. ¿Cómo prefieres quedarte? <ul className="list-disc p-4"><li>¿Viajas solo o en pareja y quieres privacidad? → Elige una Hub.</li><li>¿Viajáis juntos pero preferís camas separadas? → Una Twin Hub es perfecta.</li><li>¿Buscas una habitación más espaciosa con baño propio? → Elige la Quad Room.</li></ul>Elijas lo que elijas, dormirás de maravilla.<br />Selecciona 1 o 2 personas para ver el precio.',
        },
        addAnotherAccomodation: {
          title: "Añadir otro alojamiento",
          hub: { title: "Hub", description: "Hub privada con cama king-size." },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privada con dos camas individuales – ideal para amigos.",
          },
          room: {
            title: "Habitación",
            description:
              "Habitación privada con literas y baño propio – ideal para hasta 4 personas.",
          },
        },
      },
      RKV: {
        tags: ["Hot tub en el hotel"],
        hub: {
          title: "Hub",
          exerpt:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          description:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          imagePath: "/assets/images/accomodation/hub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            { src: "see_the_top_hub.jpg", alt: "Ver la Hub superior" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interior de la Hub superior",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Ver la Hub inferior" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interior de la Hub inferior",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sí, puedes sentarte en la cama",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relájate en nuestro hot tub en la azotea",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          exerpt:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio. Genial para amigos o hermanos.",
          description:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio.",
          imagePath: "/assets/images/accomodation/twinHub_RKV/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            {
              src: "inside_the_top_twin_hub.jpg",
              alt: "Interior de la Twin Hub superior",
            },
            {
              src: "inside_the_bottom_twin_hub.jpg",
              alt: "Interior de la Twin Hub inferior",
            },
            {
              src: "two_separate_beds_with_a_divider.jpg",
              alt: "2 colchones individuales con un divisor",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relájate en nuestro hot tub en la azotea",
            },
          ],
        },
        movieHub: {
          title: "Movie Hub",
          exerpt: "Hub privada con cama king-size y pantalla de TV grande.",
          description:
            "Esta habitación compacta para hasta 2 viajeros cuenta con una cama king-size y una televisión de pantalla grande. Ideal para maratones de películas desde la cama.",
          imagePath: "/assets/images/accomodation/movieHub_RKV/",
          images: [
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "large_tv_for_your_favourite_shows.jpg",
              alt: "TV grande para tus series favoritas",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "relax_in_our_rooftop_hot_tub.jpg",
              alt: "Relájate en nuestro hot tub en la azotea",
            },
          ],
        },
        howManyTravellers: {
          title: "¿Cuántos viajeros?",
          content:
            'Nuestros espacios ofrecen camas cómodas y tecnología. La pregunta es: ¿cómo quieres alojarte? <ul className="list-disc p-4"><li>¿Privacidad y ambiente acogedor? → Elige una Hub.</li><li>¿Camas separadas? → Una Twin Hub es perfecta.</li><li>¿Habitación tradicional con TV grande (baño compartido)? → Elige la Movie Hub.</li></ul>',
        },
        addAnotherAccomodation: {
          title: "Añadir otro alojamiento",
          hub: { title: "Hub", description: "Hub privada con cama king-size." },
          twinHub: {
            title: "Twin Hub",
            description: "Hub privada con 2 camas individuales.",
          },
          movieHub: {
            title: "Movie Hub",
            description: "Habitación privada con cama king-size y TV.",
          },
        },
      },
      RTM: {
        tags: [],
        hub: {
          title: "Hub",
          exerpt:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          description:
            "Tu propia Hub privada para hasta 2 viajeros con una cama king-size. Perfecta para quienes viajan solos, amigos o parejas que buscan confort.",
          imagePath: "/assets/images/accomodation/hub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            { src: "see_the_top_hub.jpg", alt: "Ver la Hub superior" },
            {
              src: "inside_the_top_hub.jpg",
              alt: "Interior de la Hub superior",
            },
            { src: "see_the_bottom_hub.jpg", alt: "Ver la Hub inferior" },
            {
              src: "inside_the_bottom_hub.jpg",
              alt: "Interior de la Hub inferior",
            },
            {
              src: "relax_in_your_king_size_bed.jpg",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "yes_you_can_sit_up_in_bed.jpg",
              alt: "Sí, puedes sentarte en la cama",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refréscate bajo la ducha de lluvia",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
          ],
        },
        twinHub: {
          title: "Twin Hub",
          exerpt:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio. Genial para amigos o hermanos.",
          description:
            "Mismo tamaño que una Hub, pero con 2 colchones individuales, edredones separados y un divisor. Ideal para 2 personas que quieren su propio espacio. Genial para amigos o hermanos.",
          imagePath: "/assets/images/accomodation/twinHub_RTM/",
          images: [
            {
              src: "one_hub_is_a_l_shaped_pod.jpg",
              alt: "Una Hub es una unidad en forma de L",
            },
            {
              src: "inside_the_bottom_twin_hub.png",
              alt: "Interior de la Twin Hub inferior",
            },
            {
              src: "relax_in_your_king_size_bed.png",
              alt: "Relájate en tu cama king-size",
            },
            {
              src: "walk_to_showers_in_our_kimonos.jpg",
              alt: "Ve a las duchas con nuestros kimonos",
            },
            { src: "women_s_bathroom.jpg", alt: "Baño de mujeres" },
            {
              src: "refresh_under_the_rain_shower.jpg",
              alt: "Refréscate bajo la ducha de lluvia",
            },
            { src: "men_s_bathroom.jpg", alt: "Baño de hombres" },
            {
              src: "free_rituals_amenities.jpg",
              alt: "Productos Rituals gratis",
            },
          ],
        },
        howManyTravellers: {
          title: "¿Cuántos viajeros?",
          content:
            'Todos nuestros alojamientos ofrecen camas cómodas y tecnología inteligente. ¿Cómo prefieres quedarte? <ul className="list-disc p-4"><li>¿Viajas solo o en pareja y quieres privacidad? → Elige una Hub.</li><li>¿Viajáis juntos pero preferís camas separadas? → Una Twin Hub es perfecta.</li></ul>Elijas lo que elijas, dormirás de maravilla.<br />Selecciona 1 o 2 personas para ver el precio.',
        },
        addAnotherAccomodation: {
          title: "Añadir Hub",
          hub: {
            title: "Hub",
            description:
              "Hub privada con cama king-size – perfecta para uno o dos viajeros.",
          },
          twinHub: {
            title: "Twin Hub",
            description:
              "Hub privada con dos camas individuales – ideal para amigos.",
          },
        },
      },
    },
    tags: {
      hub: [
        "Hub privada para 1-2 personas",
        "1 cama king-size",
        "Baños compartidos",
        "Productos Rituals",
        "Toallas",
        "Kimonos",
      ],
      twinHub: [
        "Hub privada para 2 personas",
        "2 colchones individuales con divisor",
        "Baños compartidos",
        "Productos Rituals",
        "Toallas",
        "Kimonos",
      ],
      room: [
        "Habitación de 20m² para 1-4 personas",
        "4 literas o 2 literas y cama doble",
        "Baño privado",
        "Productos Rituals",
        "Toallas",
        "Kimonos",
        "Accesible para sillas de ruedas",
      ],
      movieHub: [
        "Hub privada para 1-2 personas",
        "1 cama king-size",
        "Baños compartidos",
        "Productos Rituals",
        "Toallas",
        "Kimonos",
        "TV",
      ],
    },
    faq: {
      hub: [
        {
          q: "¿Hub superior o inferior? ¿Puedo elegir?",
          a: "Sí. Una Hub es tu cabina privada, en forma de L y diseñada para 2 personas. Las Hubs están apiladas: una arriba y otra abajo. Al hacer el check-in, decides si prefieres subir o entrar directamente.",
        },
        {
          q: "Cuéntame más sobre esta Hub.",
          a: "Tu Hub de 6 m² tiene almacenamiento inteligente, enchufes y WiFi. Las camas ya están hechas. Puedes ajustar las luces con la app de CityHub. Incluye música por Bluetooth.",
        },
        {
          q: "¿Hay aire acondicionado en la Hub?",
          a: "Sí, tu Hub está conectada a un sistema de climatización central para el máximo confort.",
        },
        {
          q: "¿Cómo son los baños?",
          a: "Lujosos. Compartidos pero separados para hombres y mujeres, con duchas de lluvia y productos Rituals gratis. Los mantenemos impecables todo el día.",
        },
        {
          q: "¿Tienen toallas? ¿Qué más no tengo que traer?",
          a: "Lo tenemos todo: toallas, jabón y champú Rituals, secadores y plancha. También tenemos kimonos CityHub. Solo trae tus propias chanclas.",
        },
        {
          q: "¿Puedo ir con niños?",
          a: "Nos encantan los niños. Sin embargo, nuestras instalaciones no son adecuadas para menores de 6 años. En una Hub caben máximo 2 personas, niños incluidos.",
        },
      ],
      twinHub: [
        {
          q: "¿Hub superior o inferior? ¿Puedo elegir?",
          a: "Sí. Una Hub es tu cabina privada, en forma de L y diseñada para 2 personas. Las Hubs están apiladas: una arriba y otra abajo. Al hacer el check-in, decides si prefieres subir o entrar directamente.",
        },
        {
          q: "Cuéntame más sobre esta Hub.",
          a: "Tu Hub de 6 m² tiene almacenamiento inteligente, enchufes y WiFi. Las camas ya están hechas. Puedes ajustar las luces con la app de CityHub. Incluye música por Bluetooth.",
        },
        {
          q: "¿Hay aire acondicionado en la Hub?",
          a: "Sí, tu Hub está conectada a un sistema de climatización central para el máximo confort.",
        },
        {
          q: "¿Cómo son los baños?",
          a: "Lujosos. Compartidos pero separados para hombres y mujeres, con duchas de lluvia y productos Rituals gratis. Los mantenemos impecables todo el día.",
        },
        {
          q: "¿Tienen toallas? ¿Qué más no tengo que traer?",
          a: "Lo tenemos todo: toallas, jabón y champú Rituals, secadores y plancha. También tenemos kimonos CityHub. Solo trae tus propias chanclas.",
        },
        {
          q: "¿Puedo ir con niños?",
          a: "Nos encantan los niños. Sin embargo, nuestras instalaciones no son adecuadas para menores de 6 años. En una Hub caben máximo 2 personas, niños incluidos.",
        },
      ],
      room: [
        {
          q: "Cuéntame más sobre esta Quad Room.",
          a: "Tu Quad Room tiene baño privado, enchufes y WiFi. Las camas estarán listas. Puedes ajustar la luz con la app de CityHub. Incluye Bluetooth.",
        },
        {
          q: "¿Hay aire acondicionado?",
          a: "Sí, tu habitación está conectada a un sistema de climatización central.",
        },
        {
          q: "¿Tienen toallas?",
          a: "Sí: toallas, productos Rituals, secador y plancha. También tenemos kimonos CityHub. Trae tus chanclas.",
        },
        {
          q: "¿Puedo ir con niños?",
          a: "Sí. Sin embargo, las zonas comunes no son adecuadas para menores de 6 años. La habitación es para máximo 4 personas, niños incluidos.",
        },
      ],
      movieHub: [
        {
          q: "Cuéntame más sobre esta Movie Hub.",
          a: "Tu Movie Hub tiene WiFi y una TV grande. Las camas están hechas. Controla las luces con la app. Incluye música por Bluetooth.",
        },
        {
          q: "¿Hay aire acondicionado?",
          a: "Sí, está conectada al sistema central de climatización.",
        },
        {
          q: "¿Cómo son los baños?",
          a: "Baños compartidos de lujo, separados por género, con duchas de lluvia y productos Rituals.",
        },
        {
          q: "¿Debo llevar toallas?",
          a: "No, incluimos toallas, productos Rituals y kimonos. Solo trae tus chanclas.",
        },
        {
          q: "¿Puedo ir con niños?",
          a: "Nuestras instalaciones comunes no son aptas para menores de 6 años. La Hub es para máximo 2 personas.",
        },
      ],
    },
    modal: {
      selectHotel: {
        title: "Elige ciudad",
        button: { label: "Elegir ciudad" },
      },
      selectCulture: {
        title: "Idioma y moneda",
        button: { label: "Guardar cambios" },
      },
      uspBar: {
        title: "Mejor precio garantizado",
        content:
          "Te garantizamos que, si reservas a través de esta web, siempre obtendrás el mejor precio posible.",
      },
    },
    component: {
      uspBar: {
        title: "Mejor precio garantizado",
      },
    },
    scenes: {
      traveller_one: "viajero",
      traveller_other: "viajeros",
      night_one: "noche",
      night_other: "noches",
      selectHotel: {
        chooseCity: "Reserva ahora, elige tu ciudad",
      },
      accommodation: {
        pricePerNight: "Precio por noche",
        pricePerNightInclVat: "Precio por noche (IVA incl.)",
        remove: "Eliminar",
        directBookingDiscount: "Descuento reserva directa",
        notAvailable: "no disponible",
        unavailable: "No disponible",
        noMoreRoomsAvailable: "Reserva ahora · última Hub",
        addAnotherRoom: "Añadir Hub",
        addAnotherHub: "Añadir otra Hub",
        howManyTravellers: "¿Cuántos viajeros?",
        questions: "Preguntas frecuentes",
        moreTags_one: "tag adicional",
        moreTags_other: "tags adicionales",
        more_info: "más info",
        not_available: "No disponible para esta fecha",
        show_more: "Más información",
        show_less: "Menos información",
        selected: "seleccionado",
      },
      calendar: {
        startNotice: "{{hotelName}} abre sus puertas el {{startDate}}",
      },
      extras: {
        perPersonPerNight: "por persona, por noche",
        add: "Añadir",
        remove: "Eliminar",
        moreInfo: "Más info",
      },
      summary: {
        perNight: "/ noche",
        checkIn: "ENTRADA",
        checkOut: "SALIDA",
        rate: "Tarifa:",
        discount: "Descuento:",
        from: "Desde",
        before: "Antes",
        total: "Total",
        incCityTax: "Tasa turística",
        incVat: "IVA incl.",
        incVatRooms: "IVA habitaciones incl.",
        incVatProducts: "IVA productos incl.",
        directBookingDiscount: "Descuento reserva directa",
        voucher: "Cupón",
        addVoucher: "Añadir cupón",
        voucherInvalid: "Código incorrecto",
        voucherNotApplicable: "Este cupón no es válido para la tarifa seleccionada",
      },
      details: {
        firstName: "Nombre",
        firstNameRequired: "El nombre es obligatorio",
        lastName: "Apellidos",
        lastNameRequired: "Los apellidos son obligatorios",
        email: "Correo electrónico",
        emailRequired: "El email es obligatorio",
        emailInvalid: "Email no válido (falta @ o punto)",
        phoneMin: "El teléfono debe tener 9 cifras",
        phoneInvalid: "Solo se permiten números",
        countryRequired: "País obligatorio",
        phone: "Teléfono",
        country: "País",
        selectCountry: "Selecciona tu país",
        specialRequests: "Peticiones especiales",
        terms:
          "Acepto los <firstLink>Términos y Condiciones</firstLink> y la <secondLink>Política de Privacidad</secondLink>.",
        marketingEmails: "Deseo recibir novedades de marketing.",
        createReservation: "Realizar reserva",
        finishPaymentAtKiosk: "Finaliza el pago en el quiosco.",
        creatingReservation: "Creando reserva...",
        reservationCreated: "¡Reserva creada!",
        somethingWentWrong: "Algo ha fallado, inténtalo de nuevo.",
      },
      payment: {
        paymentMethods: "Métodos de pago",
        paymentMethodsDescription:
          "Último paso – finaliza tu pago de forma segura. Usamos métodos cifrados para proteger tus datos. Recibirás una confirmación por email.",
        authorizeCreditCard: "Autorizar tarjeta",
        cardChargeInfo: "El cargo se hará 48h antes de la llegada",
        securedWithMews: "Protegido por Mews Payments",
        payWithCreditCard: "Pagar con tarjeta",
        payDirectly: "Pagar directamente",
        onlyVisaAndMastercardSupported: "Solo Visa y MasterCard",
        nameOnCreditCard: "Nombre en la tarjeta",
        cardNumber: "Número de tarjeta",
        expirationDate: "Caducidad",
        expirationDateRequired: "Falta caducidad",
        yearCanNotBeInThePast: "El año no puede ser pasado",
        yearCanNotBeMoreThan5YearsInTheFuture: "Máximo 5 años a futuro",
        monthCanNotBeInThePast: "Mes no válido",
        monthCanNotBeBiggerThan12: "Mes incorrecto",
        shouldBeAMonthAndAYear: "Formato MM/AAAA",
        validateCard: "Validar tarjeta",
        createReservation: "Realizar reserva",
        nameIsRequired: "Falta nombre",
        cardNumberIsRequired: "Falta número",
        invalidCardNumber: "Número no válido",
        cvcIsRequired: "Falta CVC",
        invalidCvc: "CVC no válido",
        somethingWentWrong: "Error. Inténtalo más tarde.",
        somethingWentWrong4501: "Error (4501). Inténtalo más tarde.",
        creatingReservation: "Creando reserva...",
        reservationCreated: "¡Reserva realizada!",
        finishPayment: "Finalizando pago...",
        creditcardNotAuthorizable: "Tarjeta no autorizable",
      },
      success: {
        bookingConfirmed: "¡Reserva confirmada!",
        bookingConfirmedDescription:
          "Tu estancia en {{hotelName}} está lista. <br/>Entrada a partir de las 15:00. ¡Nos vemos! 👋",
        startChatting: "Empezar chat",
        viewBookingDetails: "Ver reserva",
        bookingDetails: "Datos de reserva",
        whatsNext: "¿Y ahora qué?",
        connectWithHost:
          "Contacta con tu CityHost 24/7 para consejos y secretos locales.",
        online: "ONLINE",
      },
      pageNotFound: {
        message: "¡Ups! <br />Página no encontrada.",
        linkText: "Elige ciudad para empezar",
      },
      redirectHotel: {
        message: "Cargando configuración...",
      },
      redirectPayment: {
        error4602: "[error" + ":4602] Sin reserva",
        noPaymentsFound: "Sin pagos",
        paymentSuccessful: "Pago con éxito",
        paymentFailed: "Pago fallido",
        returningToSite: "Volviendo a la web...",
        authorizationPending: "Autorización pendiente",
        authorizationPendingMessage:
          "Reserva creada, autorización pendiente.<br /><br />Pulsa aquí para autorizar tu tarjeta.",
      },
    },
    form: {
      language: {
        label: "Idioma",
        placeholder: "Elige idioma",
        options: {
          "en-US": "Inglés",
          "nl-NL": "Holandés",
          "de-DE": "Alemán",
          "fr-FR": "Francés",
          "it-IT": "Italiano",
          "is-IS": "Islandés",
          "da-DK": "Danés",
          "es-ES": "Español",
        },
        validation: { required: "Falta idioma" },
      },
      currency: {
        label: "Moneda",
        placeholder: "Elige moneda",
        options: {
          EUR: "Euro (€)",
          USD: "Dólar US ($)",
          GBP: "Libra (£)",
          CAD: "Dólar Canadiense (C$)",
          DKK: "Corona Danesa (DKK)",
          ISK: "Corona Islandesa (ISK)",
        },
        validation: { required: "Falta moneda" },
      },
    },
  },
};
